const isField = (formField, name, objectTypeId) => formField.name === name && formField.objectTypeId === objectTypeId;
export default isField;